import * as React from 'react';

export const LightbulbSvg = ({}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 100 148 204" preserveAspectRatio="true">
    <g fill="none">
      <path fill="#3C3C3C" d="M70.221 161.2L77.501 161.2 77.501 0 70.221 0z" />
      <path
        fill="#FFF"
        d="M74.063 266.572c-24.105 0-43.645-19.54-43.645-43.645 0-24.105 19.54-43.645 43.645-43.645 24.105 0 43.644 19.54 43.644 43.645 0 24.105-19.54 43.645-43.644 43.645"
      />
      <path
        fill="#FFDB8D"
        d="M66.986 303.885L80.345 303.885 80.345 276.973 66.986 276.973zM94.879 273.086L106.452 266.406 119.909 289.715 108.337 296.397 94.879 273.086M117.112 255.752L123.791 244.182 147.1 257.639 140.421 269.209 117.112 255.752M40.841 266.417L52.408 273.096 38.953 296.403 27.383 289.726 40.841 266.417M23.504 244.184L30.183 255.754 6.874 269.212.195 257.642 23.504 244.184"
      />
      <path
        fill="#FFC743"
        d="M74.092 179.31c24.103 0 43.645 19.54 43.645 43.644h-28.98c0-8.1-6.566-14.665-14.665-14.665-8.1 0-14.666 6.566-14.666 14.665h-28.98c0-24.104 19.541-43.644 43.646-43.644"
      />
      <path fill="#231F20" d="M104.824 191.963L43.1 253.687 43.36 253.945 105.084 192.223" />
      <path fill="#231F20" d="M105.084 253.687L43.36 191.963 43.1 192.223 104.824 253.945" />
      <path
        fill="#FFC72C"
        d="M74.092 266.6c-24.105 0-43.645-19.54-43.645-43.646 0-12.052 4.886-22.963 12.783-30.861.583-.583 1.182-1.15 1.797-1.698 3.159-2.916 8.919-8.066 12.19-11.337 3.233-3.233 3.094-6.193 3.094-10.326 0-2.638-.178-6.279 1.148-7.135h25.265c1.325.856 1.147 4.497 1.147 7.135 0 4.133-.137 7.093 3.096 10.326 3.272 3.271 9.03 8.42 12.188 11.337.617.549 1.216 1.115 1.799 1.698 7.895 7.898 12.783 18.81 12.783 30.861 0 24.105-19.542 43.645-43.645 43.645"
      />
      <path
        fill="#3C3C3C"
        d="M59.965 167.86l-3.233-3.487v-36.249s4.819-.903 8.363-4.542c3.788-3.89 3.469-8.918 3.469-16.102h11.055c0 7.184-.319 12.212 3.47 16.102 3.543 3.64 8.361 4.542 8.361 4.542v36.249l-3.23 3.486H59.965"
      />
      <path fill="#6E6E6E" d="M56.732 164.372L91.45 164.372 91.45 149.734 56.732 149.734z" />
      <path
        fill="#FFDB8D"
        d="M74.092 266.6c-24.105 0-43.645-19.54-43.645-43.646h28.98c0 8.1 6.565 14.666 14.665 14.666 8.1 0 14.666-6.566 14.666-14.666h28.98c0 24.105-19.543 43.645-43.646 43.645"
      />
      <path
        fill="#3C3C3C"
        d="M56.732 128.124s4.819-.903 8.363-4.542c1.56-1.602 2.423-3.371 2.9-5.4h12.193c.476 2.029 1.34 3.798 2.9 5.4 3.544 3.64 8.362 4.542 8.362 4.542H56.732"
      />
      <path fill="#6E6E6E" d="M56.732 146.247L91.45 146.247 91.45 131.609 56.732 131.609z" />
    </g>
  </svg>
);
